import { __assign } from "tslib";
// Mapping that describes default error codes such as network_error and unknown.
// These are both two edge cases: network error - when request has fallen due to problems with
// network (no internet connection, server is down) and unknown when
// response has no defined error code
var baseErrorMapping = {
    network_error: 'Network error',
    unknown: 'Unknown error',
};
// Network error constant that axios returns in case if request failed
var axiosNetworkError = 'Network Error';
/**
 * Returns formatted error (when you need to display human-friendly error message)
 *
 * formatError(
 *     error,
 *     {
 *         mapping: {'conflict': 'Please reload page'},
 *         format: (errorCode, errorDescription) =>
 *             `An error occurred: ${errorDescription} (${errorCode}). Please reach tech support`
 *     }
 * )
 */
export function formatError(error, config) {
    if (config === void 0) { config = {}; }
    var mapping = config.mapping, format = config.format;
    var extendedMapping = __assign(__assign({}, baseErrorMapping), mapping);
    var errorCode = extractErrorCode(error);
    if (errorCode in extendedMapping) {
        return extendedMapping[errorCode];
    }
    var errorDescription = extractErrorDescription(error);
    if (format) {
        return format(errorCode, errorDescription);
    }
    return errorDescription + " (" + errorCode + ")";
}
export function extractErrorDescription(error) {
    var _a, _b, _c, _d, _e;
    if (error === axiosNetworkError) {
        return baseErrorMapping.network_error;
    }
    if (isOperationOutcome(error)) {
        if ((_c = (_b = (_a = error.issue) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.details) === null || _c === void 0 ? void 0 : _c.text) {
            return error.issue[0].details.text;
        }
        if ((_e = (_d = error.issue) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.diagnostics) {
            return error.issue[0].diagnostics;
        }
    }
    if (isBackendError(error) && error.error_description) {
        return error.error_description;
    }
    return baseErrorMapping.unknown;
}
export function extractErrorCode(error) {
    if (error === axiosNetworkError) {
        return 'network_error';
    }
    if (isOperationOutcome(error)) {
        return error.issue[0].code;
    }
    if (isBackendError(error)) {
        return error.error;
    }
    return 'unknown';
}
function isObject(value) {
    return value && typeof value === 'object' && !(value instanceof Array);
}
export function isOperationOutcome(error) {
    return isObject(error) && error.resourceType === 'OperationOutcome';
}
export function isBackendError(error) {
    return isObject(error) && error.error;
}
//# sourceMappingURL=error.js.map